"use client";

import { Card, CardContent } from "@/components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";

import { BLUR_DATA_URL } from "@/config/site";
import Image from "next/image";

const SLIDE_IMAGES = [
  "/images/banners/T1.png",
  "/images/banners/T2.png",
  "/images/banners/T3.png",
];

const PromoSlideCard = ({ imageUrl }: { imageUrl: string }) => (
  <CarouselItem className="md:basis-1/3">
    <Card className="relative h-40 overflow-hidden shadow-md p-0">
      <CardContent className="relative h-full p-0">
        <Image
          fill
          src={imageUrl}
          alt="Promo Slide"
          className="object-cover"
          placeholder="blur"
          blurDataURL={BLUR_DATA_URL}
          sizes="(min-width: 768px) 33vw, 100vw"
          quality={70}
          loading="lazy"
        />
      </CardContent>
    </Card>
  </CarouselItem>
);

export function PromoSlider() {
  return (
    <Carousel className="w-full ">
      <CarouselContent className="py-4">
        {SLIDE_IMAGES.map((url, idx) => (
          <PromoSlideCard key={idx} imageUrl={url} />
        ))}
      </CarouselContent>
    </Carousel>
  );
}
